import { atom } from "jotai";

export const isSocketConnectedAtom = atom<boolean>(false);
